import { Tab, Transition } from "@headlessui/react";
import classNames from "classnames";
import { Fragment, Key, useEffect, useState } from "react";
import {
  fetchInvoiceStatus,
  getAssigneeList,
} from "src/services/invoice-api";
import { invoiceActions } from "src/context/invoice-slice";
import { useDispatch, useSelector } from "react-redux";
import filterIcon from "src/assets/filterIcon.svg";
import { Button, Input } from "src/components";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import { getAllCompanyDetails } from "src/services/company-api";
import { RootState } from "src/context/store";
import InvoiceFiltersComponent from "../../features/fields/container/InvoiceFilters";
import { getCityDetails, getDistrictDetails, getStateDetails } from "src/services/region-api";
import AllTextract from "./textract-all.component";

const TextractEntry = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const dispatch = useDispatch();
  const { InvoiceFiltersData,InvoiceFilters } = useSelector((state: RootState) => state.invoice);
  const [searchValue, setSearchValue] = useState("");
  const textractAnalysisData=["Non-MV Lens Stockist","MV Lens Stockist"] //Removed All Stockist - change name

  const ref = useOutsideClick(() => setIsFilterOpen(false));

  const company_code = InvoiceFilters?.company?.[0]?.code;

  useEffect(() => {
    const fetchInitialFilterData = async () => {
      try {
        if (!InvoiceFiltersData?.status?.length) {
          const res = await fetchInvoiceStatus(company_code);  //textract filter
          dispatch(invoiceActions.setInvoiceFiltersData({ key: "status", value: res?.data }));
        }
        if (!InvoiceFiltersData?.assignee?.length) {
          const res = await getAssigneeList(company_code);
          dispatch(invoiceActions.setInvoiceFiltersData({ key: "assignee", value: res?.data?.data }));
        }
        if (!InvoiceFiltersData?.company?.length) {
          const res = await getAllCompanyDetails();
          dispatch(invoiceActions.setInvoiceFiltersData({ key: "company", value: res?.data }));
        }
        if (!InvoiceFiltersData?.city?.length) {
          const res = await getCityDetails("");
          dispatch(invoiceActions.setInvoiceFiltersData({ key: "city", value: res?.data?.data }));
        }
        if (!InvoiceFiltersData?.district?.length) {
          const res = await getDistrictDetails("");
          dispatch(invoiceActions.setInvoiceFiltersData({ key: "district", value: res?.data?.data }));
        }
        if (!InvoiceFiltersData?.state?.length) {
          const res = await getStateDetails("");
          dispatch(invoiceActions.setInvoiceFiltersData({ key: "state", value: res?.data?.data }));
        }
      } catch (err) {
        console.error("Error fetching filter data:", err);
      }
    };
    fetchInitialFilterData();
  }, [dispatch]);

  return (
    <div className="w-full">
      <Transition
        as={Fragment}
        show={isFilterOpen}
        enter="transition ease-in-out duration-200 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition ease-in-out duration-200 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
      >
        <div className="fixed right-0 inset-0 top-0 z-[500]">
          <InvoiceFiltersComponent
            companyDetails={InvoiceFiltersData?.company || []}
            divisionDetails={InvoiceFiltersData?.division || []}
            stockistDetails={InvoiceFiltersData?.stockist || []}
            statusDetails={InvoiceFiltersData?.status || []}
            assigneeDetails={InvoiceFiltersData?.assignee || []}
            cityDetails={InvoiceFiltersData?.city || []}
            districtDetails={InvoiceFiltersData?.district || []}
            stateDetails={InvoiceFiltersData?.state || []}
            ref={ref}
            onClose={() => setIsFilterOpen(false)}
          />
        </div>
      </Transition>
      <div className="mx-auto">
        <div className="px-2 py-2 w-full sm:px-0">
          <Tab.Group selectedIndex={selectedTab} onChange={setSelectedTab}>
            <div className="flex justify-between">
              <Tab.List className="flex p-1 space-x-1 rounded-lg bg-[#e3e3e3] w-[500px] h-[38px] items-center">
                {textractAnalysisData.map((value: any, index: Key | null | undefined) => (
                  <Tab
                    key={index}
                    className={({ selected }) =>
                      classNames(
                        "w-full rounded-md py-1.5 text-sm font-normal leading-5",
                        "focus:outline-none",
                        selected ? "bg-white" : "hover:bg-white/[0.12] hover:text-black"
                      )
                    }
                  >
                    {value}
                  </Tab>
                ))}
              </Tab.List>

              <div className="flex items-center gap-2 h-full">
                <div className="flex items-center w-[400px] rounded-md overflow-hidden border border-gray-300 bg-white">
                  <Input
                    placeholder="Search by PH Code"
                    debounceTime={500}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value.trim())}
                    containerClasses="w-full px-3 py-1 text-gray-700 border-none bg-white focus:outline-none focus:ring-0 focus:shadow-none"
                  />
                </div>
                <div className="flex items-center gap-2 h-full relative">
                  {Object.values(InvoiceFilters).some((value: any) => value?.length > 0) && (
                    <span className="absolute top-[-10px] right-[-10px] w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs">
                      {Object.values(InvoiceFilters).filter((value: any) => value?.length > 0).length}
                    </span>
                  )}
                  <Button className="bg-[#F1F1F1]" onClick={() => setIsFilterOpen(true)}>
                    <img src={filterIcon} alt="filter-icon" />
                  </Button>
                </div>
              </div>
            </div>
            <Tab.Panels className="">
              <Tab.Panel>
                <AllTextract searchValue={searchValue} textract={"false"} />
              </Tab.Panel>
              <Tab.Panel>
                <AllTextract searchValue={searchValue} textract={"true"} />
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    </div>
  );
};

export default TextractEntry;
